import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "app.title": "CellySheets",
      "nav.dashboard": "Dashboard",
      "nav.personal": "Personal",
      "nav.myDocuments": "My Documents",
      "nav.upgradePlan": "Upgrade Plan",
      "nav.manageBilling": "Manage Billing",
      "nav.profileSettings": "Profile Settings",
      "nav.logout": "Log out {{name}}",
      "nav.installApp": "Install App",
      "dashboard.privateSpreadsheets": "Private spreadsheets owned by you.",
      "dashboard.sharedWorkspace": "Shared team workspace.",
      "dashboard.importFile": "Import File",
      "dashboard.createPrivateDoc": "+ Create Private Doc",
      "dashboard.createTeamDoc": "+ Create Team Doc",
      "dashboard.size": "Size: {{size}}",
      "dashboard.edited": "Edited: {{date}}",
      "dashboard.noSpreadsheets": "No spreadsheets found here.",
      "dashboard.startNew": "Start a new document to begin collaborating.",
      "header.tryCellySheets": "Try CellySheets",
      "header.untitled": "Untitled Spreadsheet",
      "header.share": "Share",
      "header.synced": "🟢 Synced",
      "header.connecting": "🟡 Connecting...",
      "header.loading": "Loading...",
      "menu.file": "File",
      "menu.edit": "Edit",
      "menu.view": "View",
      "menu.insert": "Insert",
      "menu.formatting": "Formatting",
      "menu.data": "Data",
      "menu.help": "Help",
      "menu.menu": "Menu",
      "install.title": "Install CellySheets",
      "install.desc": "Add to your home screen for faster access.",
      "install.button": "Install",
      "install.notNow": "Not now",
      "install.iosInstructions": "To install on iOS: tap the Share icon at the bottom of Safari and select 'Add to Home Screen'."
    }
  },
  fr: {
    translation: {
      "app.title": "CellySheets",
      "nav.dashboard": "Tableau de bord",
      "nav.personal": "Personnel",
      "nav.myDocuments": "Mes documents",
      "nav.upgradePlan": "Mettre à niveau",
      "nav.manageBilling": "Gérer la facturation",
      "nav.profileSettings": "Paramètres du profil",
      "nav.logout": "Déconnexion {{name}}",
      "nav.installApp": "Installer l'appli",
      "dashboard.privateSpreadsheets": "Feuilles de calcul privées vous appartenant.",
      "dashboard.sharedWorkspace": "Espace de travail d'équipe partagé.",
      "dashboard.importFile": "Importer un fichier",
      "dashboard.createPrivateDoc": "+ Créer un doc privé",
      "dashboard.createTeamDoc": "+ Créer un doc d'équipe",
      "dashboard.size": "Taille : {{size}}",
      "dashboard.edited": "Modifié : {{date}}",
      "dashboard.noSpreadsheets": "Aucune feuille de calcul trouvée ici.",
      "dashboard.startNew": "Commencez un nouveau document pour collaborer.",
      "header.tryCellySheets": "Essayer CellySheets",
      "header.untitled": "Feuille de calcul sans titre",
      "header.share": "Partager",
      "header.synced": "🟢 Synchronisé",
      "header.connecting": "🟡 Connexion...",
      "header.loading": "Chargement...",
      "menu.file": "Fichier",
      "menu.edit": "Édition",
      "menu.view": "Affichage",
      "menu.insert": "Insertion",
      "menu.formatting": "Formatage",
      "menu.data": "Données",
      "menu.help": "Aide",
      "menu.menu": "Menu",
      "install.title": "Installer CellySheets",
      "install.desc": "Ajouter à l'écran d'accueil pour un accès plus rapide.",
      "install.button": "Installer",
      "install.notNow": "Plus tard",
      "install.iosInstructions": "Pour installer sur iOS : appuyez sur l'icône Partager au bas de Safari et sélectionnez 'Sur l'écran d'accueil'."
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('ehxcel_language') || 'en', // Default to localStorage or English
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already escapes by default
    }
  });

export default i18n;